module.exports = __webpack_public_path__ + "img/offenen-positionen-v1.27374c1d.jpg";